import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import CalendarItem from '@calendar/components/View/CalendarItem.vue'
import WebMailBottom from '@/components/common/WebMailBottom.vue'
import { mapActions, mapGetters } from 'vuex'
import * as types from '@calendar/store/types'
import * as dateutil from '@/util/date-helper'
@Component({
    components: { CalendarItem, WebMailBottom },
    computed: {
        ...mapGetters({
            monthMatrix: types.CALENDAR_MONTH_MATRIX_LIST,
            dateMatrix: types.CALENDAR_DATE_MATRIX_LIST,
            currentDate: types.COMMON_DATE_CURRENT,
        })
    },
    methods: {
        ...mapActions({
            selectDate: types.COMMON_DATE_SELECT,
        })
    }
})
export default class DayView extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    monthMatrix!: Array<Array<calendar.DateItem>>
    dateMatrix!: Array<Array<calendar.DateItem>>
    currentDate!: calendar.DateItem

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    selectDate!: (item: calendar.DateItem) => void

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    Select!: calendar.DateItem

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    get weekSlideList() {
        let WP = dateutil.uGetWeekStartPrev(this.currentDate.date);
        let W = dateutil.uGetWeekStartDate(this.currentDate.date);
        let WN = dateutil.uGetWeekEndNext(this.currentDate.date);
        let WPL = [] = dateutil.uGetDaysInWeek(WP);
        let WL = [] = dateutil.uGetDaysInWeek(W);
        let WNL = [] = dateutil.uGetDaysInWeek(WN);
        let All = WPL.concat(WL);
        let AllT = All.concat(WNL);

        return AllT.map((x) => {
            if (!this.Select) {
                this.Select = this.currentDate;
            }
            let isSelected = dateutil.uGetDateFormat('yyyy-MM-DD', x) == dateutil.uGetDateFormat('yyyy-MM-DD', this.Select.date);
            let isToday = dateutil.uGetDateFormat('yyyy-MM-DD', x) == dateutil.uGetDateFormat('yyyy-MM-DD');
            return {
                value: x.getDate(),
                date: x,                // 날짜
                isToday: isToday,       // 오늘인지 여부
                isSelected: isSelected, // 선택여부        
                isSun: x.getDay() == 0, // 일요일 여부
                isSat: x.getDay() == 6, // 토요일 여부 
            }
        })
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    @Watch('monthMatrix')
    onMatrixChanged(newVal: Array<Array<calendar.DateItem>>) {
        this.$nextTick(() => {       
            this.dayScrollFitTo('date selected');
        });
    }

    @Watch('currentDate')
    onCurrentDateChanged(newVal: calendar.DateItem) {
        this.Select = this.currentDate
    }

    getDayDate(witem: calendar.DateItem) {
        witem.isSelected = true;
        this.selectDate(witem);
        this.Select = witem;

        this.dayScrollFitTo('date selected');
    }

    dayScrollFitTo(selector: string) { 
        var dayWrap = this.$refs.dayWrap as HTMLDivElement;

        if(dayWrap) {           
            var bodyWidth = document.body.clientWidth / 2;
            var selectElem = document.getElementsByClassName(selector)[0] as HTMLElement;
            dayWrap.scrollLeft = selectElem.offsetLeft - bodyWidth;           
        }                           
    }
}
